import { DocsBlockPropertyDefinition, } from "./SDKDocsBlockProperty";
/** ComponentProperty property - Definition */
export class DocsBlockComponentPropertyPropertyDefinition extends DocsBlockPropertyDefinition {
}
